export const patientUser = {
  patientCreated: "Patient user created successfully",
  patientUpdated: "Patient user updated successfully",
  welcomeMessageSent: "Patient welcome message sent"
};
